export default "__VITE_ASSET__AMK_N2$B__"